"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.brightness = brightness;
exports["default"] = exports.siteColors = exports.palePink = exports.lightPink = exports.lightTan = exports.lightSteel = exports.tan = exports.steel = exports.armyGreen = exports.poppyRed = exports.cobaltBlue = exports.fbMessenger = exports.whiteSmoke = exports.mystic = exports.iron = exports.jumbo = exports.mineShaft = exports.black = exports.white = exports.dusk = exports.goldfish = exports.bearLake = exports.podiumBrand = void 0;

var _polished = require("polished");

// V1 Colors
var podiumBrand = '#22d85d';
exports.podiumBrand = podiumBrand;
var bearLake = '#179be5'; // blu'e

exports.bearLake = bearLake;
var goldfish = '#ffc636'; // gol'd

exports.goldfish = goldfish;
var dusk = '#e66a5c';
exports.dusk = dusk;
var white = '#ffffff';
exports.white = white;
var black = '#000000';
exports.black = black;
var mineShaft = '#2d2f31';
exports.mineShaft = mineShaft;
var jumbo = '#878787';
exports.jumbo = jumbo;
var iron = '#cccccc';
exports.iron = iron;
var mystic = '#e4e9f0';
exports.mystic = mystic;
var whiteSmoke = '#f4f6f9';
exports.whiteSmoke = whiteSmoke;
var fbMessenger = '#0084FF'; // V2 Colors

exports.fbMessenger = fbMessenger;
var cobaltBlue = '#4C76E0';
exports.cobaltBlue = cobaltBlue;
var poppyRed = '#E73E51';
exports.poppyRed = poppyRed;
var armyGreen = '#63674E';
exports.armyGreen = armyGreen;
var steel = '#63727d';
exports.steel = steel;
var tan = '#E9E5E0';
exports.tan = tan;
var lightSteel = '#ADB6BE';
exports.lightSteel = lightSteel;
var lightTan = '#F4F2EF';
exports.lightTan = lightTan;
var lightPink = '#fef8f9';
exports.lightPink = lightPink;
var palePink = '#F6C5C4';
exports.palePink = palePink;
var siteColors = {
  'angies-list': '#27A149',
  angieslist: '#27A149',
  avvo: '#0c4277',
  bbb: '#005a78',
  booking: '#0C3B7C',
  bestcompany: '#375273',
  carfax: '#231F20',
  'car-gurus': '#00A3E0',
  cargurus: '#00A3E0',
  cars: '#4d217d',
  citysearch: '#449ff4',
  'consumer-affairs': '#166ba1',
  consumeraffairs: '#166ba1',
  custom: '#3d3d3d',
  'dealer-rater': '#ea6322',
  dealerrater: '#ea6322',
  doctor: '#2AB3AD',
  edmunds: '#007ee5',
  expedia: '#072F54',
  facebook: '#5173b3',
  g2crowd: '#446373',
  'g-2-crowd': '#446373',
  goodbed: '#5A934F',
  google: '#4285F4',
  healthgrades: '#0e4673',
  'home-advisor': '#F19200',
  homeadvisor: '#F19200',
  'merchant-circle': '#f15b50',
  merchantcircle: '#f15b50',
  'product-review': '#88BF60',
  productreview: '#88BF60',
  'solar-reviews': '#01a9e8',
  solarreviews: '#01a9e8',
  'trip-advisor': '#00b087',
  tripadvisor: '#00b087',
  vitals: '#3c1951',
  'yellow-pages': (0, _polished.lighten)(0.06, '#ffd400'),
  yellowpages: (0, _polished.lighten)(0.06, '#ffd400'),
  yelp: '#cf1a08',
  zillow: '#0074e4'
};
exports.siteColors = siteColors;

function brightness(color) {
  var _parseToRgb = (0, _polished.parseToRgb)(color),
      red = _parseToRgb.red,
      green = _parseToRgb.green,
      blue = _parseToRgb.blue;

  var r = red;
  var g = green;
  var b = blue;
  return (0.241 * r * r + 0.691 * g * g + 0.068 * b * b) / 255 / 255 * 100;
}

var _default = {
  podiumBrand: podiumBrand,
  bearLake: bearLake,
  goldfish: goldfish,
  dusk: dusk,
  white: white,
  black: black,
  mineShaft: mineShaft,
  jumbo: jumbo,
  iron: iron,
  mystic: mystic,
  whiteSmoke: whiteSmoke,
  fbMessenger: fbMessenger,
  siteColors: siteColors,
  brightness: brightness,
  cobaltBlue: cobaltBlue,
  poppyRed: poppyRed,
  armyGreen: armyGreen,
  steel: steel,
  tan: tan,
  lightSteel: lightSteel,
  lightTan: lightTan,
  palePink: palePink
};
exports["default"] = _default;